const translations = {
  es: {
    nav: {
      about: "Nosotros",
      services: "Servicios",
      features: "Destacados",
      workflow: "Proceso",
      games: "Juegos",
      contact: "Contacto",
      cta: "Hablemos",
    },
    hero: {
      title1: "Creamos videojuegos",
      title2: "que inspiran.",
      subtitle: "Desarrollamos experiencias mobile para Android e iOS con identidad, creatividad y tecnologia de vanguardia.",
      cta1: "Nuestra vision",
    },
    about: {
      tag: "Quienes somos",
      title: "Un estudio con vision creativa y tecnica",
      description: "En Realm Pixel Games combinamos diseno visual distintivo, mecanicas innovadoras y optimizacion tecnica para crear videojuegos mobile que destacan. Cada proyecto nace de una idea audaz y se transforma en una experiencia memorable.",
      values: [
        { title: "Creatividad", desc: "Ideas originales que rompen esquemas y generan experiencias unicas." },
        { title: "Gameplay", desc: "Mecanicas adictivas pensadas para engagement y retencion." },
        { title: "Diseno Visual", desc: "Estetica cuidada con identidad propia en cada pixel." },
        { title: "Mobile First", desc: "Optimizacion nativa para Android e iOS desde el dia uno." },
        { title: "Innovacion", desc: "Tecnologia de punta aplicada al desarrollo de videojuegos." },
      ],
    },
    services: {
      tag: "Que hacemos",
      title: "Servicios de desarrollo",
      items: [
        { title: "Juegos para Android", desc: "Desarrollo nativo y optimizado para el ecosistema Android con rendimiento excepcional." },
        { title: "Juegos para iOS", desc: "Experiencias pulidas y fluidas disenadas para el ecosistema Apple." },
        { title: "Diseno de Mecanicas", desc: "Gameplay loops adictivos, sistemas de progresion y balanceo de juego." },
        { title: "UI/UX Gaming", desc: "Interfaces intuitivas y atractivas que potencian la experiencia del jugador." },
        { title: "Optimizacion", desc: "Rendimiento maximo en dispositivos moviles sin sacrificar calidad visual." },
        { title: "Prototipado", desc: "Conceptualizacion rapida y prototipos funcionales para validar ideas." },
      ],
    },
    features: {
      tag: "Por que elegirnos",
      title: "Lo que nos hace diferentes",
      items: [
        { title: "Experiencias Atractivas", desc: "Juegos que capturan la atencion desde el primer segundo." },
        { title: "Diseno Distintivo", desc: "Identidad visual unica que destaca en cualquier tienda de apps." },
        { title: "Rendimiento Optimizado", desc: "Fluidez garantizada incluso en dispositivos de gama media." },
        { title: "Enfoque en Engagement", desc: "Mecanicas pensadas para que los jugadores vuelvan una y otra vez." },
        { title: "Multiplataforma", desc: "Un juego, multiples plataformas. Android e iOS sin compromiso." },
        { title: "Vision Creativa", desc: "Cada proyecto es una oportunidad para crear algo extraordinario." },
      ],
    },
    workflow: {
      tag: "Nuestro proceso",
      title: "De la idea al lanzamiento",
      steps: [
        { title: "Idea", desc: "Todo comienza con una vision. Exploramos conceptos y definimos la direccion creativa." },
        { title: "Concepto", desc: "Estructuramos la mecanica central, narrativa y estetica del juego." },
        { title: "Diseno", desc: "Creamos el arte visual, UI/UX y la identidad grafica completa." },
        { title: "Desarrollo", desc: "Programacion, integracion de sistemas y construccion del producto." },
        { title: "Testing", desc: "QA riguroso, pruebas de rendimiento y ajustes de balanceo." },
        { title: "Lanzamiento", desc: "Publicacion en stores, estrategia de lanzamiento y marketing." },
        { title: "Evolucion", desc: "Updates, contenido nuevo y mejora continua basada en datos." },
      ],
    },
    portfolio: {
      tag: "Nuestros juegos",
      title: "Proyectos que cobran vida",
      games: [
        { title: "Neon Drift", genre: "Accion / Arcade", platform: "Android & iOS", status: "En Desarrollo", desc: "Carreras futuristas a velocidad extrema por ciudades neon." },
        { title: "Pixel Realms", genre: "RPG / Aventura", platform: "Android & iOS", status: "Prototipo", desc: "Un mundo pixelado lleno de misterios, mazmorras y magia." },
        { title: "Cyber Stack", genre: "Puzzle / Estrategia", platform: "Android", status: "Proximamente", desc: "Apila, conecta y hackea tu camino a traves de niveles cyberpunk." },
        { title: "Shadow Sprint", genre: "Plataformas / Runner", platform: "iOS", status: "Concepto", desc: "Corre, salta y esquiva en un mundo de sombras y luces." },
      ],
    },
    cta: {
      title: "Construyamos el proximo gran juego mobile",
      subtitle: "Tienes una idea? Nosotros la convertimos en una experiencia que los jugadores amaran.",
      button: "Contactanos",
    },
    contact: {
      tag: "Contacto",
      title: "Hablemos de tu proyecto",
      subtitle: "Estamos listos para escuchar tu idea y convertirla en realidad.",
      name: "Tu nombre",
      email: "Tu email",
      message: "Tu mensaje",
      send: "Enviar mensaje",
      info: {
        email: "Email",
        social: "Redes Sociales",
        location: "Ubicacion",
        locationValue: "Global / Remoto",
      },
    },
    footer: {
      tagline: "Creando experiencias mobile extraordinarias.",
      rights: "Todos los derechos reservados.",
      nav: "Navegacion",
      social: "Social",
    },
    privacy: {
      badge: "Legal",
      title: "Política de Privacidad",
      updated: "Última actualización: 8 de abril de 2025",
      back: "Volver",
      sections: [
        {
          title: "1. Introducción",
          content: [
            { type: "paragraph", text: "Realm Pixel Games ('nosotros', 'nuestro') opera este sitio web y los juegos móviles disponibles en Google Play Store y Apple App Store. Esta Política de Privacidad explica cómo recopilamos, usamos, compartimos y protegemos tu información cuando usas nuestros servicios." },
            { type: "paragraph", text: "Al usar nuestros servicios, aceptas las prácticas descritas en esta política. Si no estás de acuerdo, te pedimos que no uses nuestros servicios." },
            { type: "email", text: "Contacto de privacidad: realmpixelgames@gmail.com" },
          ],
        },
        {
          title: "2. Información que Recopilamos",
          content: [
            { type: "paragraph", text: "Recopilamos los siguientes tipos de información:" },
            { type: "list", items: [
              "Identificadores de dispositivo: ID de publicidad (GAID en Android, IDFA en iOS), modelo de dispositivo, sistema operativo y versión.",
              "Dirección IP: utilizada para determinar la región geográfica aproximada.",
              "Datos de juego: progreso, puntuaciones, logros, tiempo de sesión y comportamiento dentro del juego.",
              "Datos de compras: historial de compras dentro de la aplicación (no almacenamos datos de tarjetas de pago).",
              "Datos técnicos: versión de la app, idioma del dispositivo, zona horaria, rendimiento y registros de errores.",
            ]},
            { type: "paragraph", text: "Parte de esta información es recopilada directamente por nosotros y parte por los SDKs de terceros integrados en nuestros juegos, según se detalla en la Sección 4." },
          ],
        },
        {
          title: "3. Cómo Usamos tu Información",
          content: [
            { type: "list", items: [
              "Operar y mejorar nuestros juegos y servicios.",
              "Mostrar anuncios relevantes (en la versión gratuita) y medir su efectividad.",
              "Procesar compras dentro de la aplicación, incluyendo la opción de eliminar anuncios.",
              "Analizar el comportamiento de juego para mejorar la experiencia del usuario.",
              "Detectar y prevenir fraudes, trampas o usos abusivos.",
              "Cumplir con obligaciones legales aplicables.",
            ]},
          ],
        },
        {
          title: "4. Publicidad y Redes de Terceros",
          content: [
            { type: "paragraph", text: "Nuestros juegos en versión gratuita muestran anuncios proporcionados por redes publicitarias de terceros. Estas redes pueden recopilar tu ID de publicidad, dirección IP y datos de uso para mostrar anuncios personalizados basados en tus intereses." },
            { type: "paragraph", text: "Trabajamos con los siguientes socios publicitarios y de análisis:" },
            { type: "table",
              headers: ["Socio", "País", "Función"],
              rows: [
                ["Google AdMob", "EE.UU.", "Red publicitaria y mediación"],
                ["Unity Ads / ironSource LevelPlay", "EE.UU. / Israel", "Red publicitaria y mediación"],
                ["AppLovin / MAX", "EE.UU.", "Red publicitaria y mediación"],
                ["Meta Audience Network", "EE.UU.", "Red publicitaria"],
                ["Vungle / Liftoff Monetize", "EE.UU.", "Anuncios de video y recompensados"],
                ["Google Firebase", "EE.UU.", "Análisis y reporte de errores"],
                ["AppsFlyer", "Israel / EE.UU.", "Atribución de marketing"],
                ["Apple App Store", "EE.UU.", "Procesamiento de compras (iOS)"],
                ["Google Play", "EE.UU.", "Procesamiento de compras (Android)"],
              ],
            },
            { type: "paragraph", text: "Puedes optar por no recibir anuncios personalizados en la configuración de tu dispositivo:" },
            { type: "list", items: [
              "iOS: Configuración > Privacidad y Seguridad > Seguimiento → desactivar 'Permitir que las Apps soliciten rastrearte'.",
              "Android: Configuración > Google > Anuncios → activar 'Inhabilitar la personalización de anuncios'.",
            ]},
          ],
        },
        {
          title: "5. Compras Dentro de la App y Opción sin Anuncios",
          content: [
            { type: "paragraph", text: "Nuestros juegos ofrecen la posibilidad de realizar una compra única para eliminar todos los anuncios. Al completar esta compra:" },
            { type: "list", items: [
              "No se mostrará ningún anuncio durante el uso de la aplicación.",
              "Dejaremos de compartir tu ID de publicidad con nuestras redes publicitarias para fines de publicidad dentro de la app.",
              "Las prácticas de recopilación de datos descritas en la Sección 4 relacionadas con publicidad no se aplicarán a tu uso de la app.",
            ]},
            { type: "paragraph", text: "El pago es procesado directamente por Apple App Store o Google Play. Realm Pixel Games no almacena ni tiene acceso a tus datos de pago. Para solicitudes de reembolso, consulta las políticas de reembolso de la plataforma correspondiente." },
          ],
        },
        {
          title: "6. Usuarios Europeos (RGPD)",
          content: [
            { type: "paragraph", text: "Si resides en el Espacio Económico Europeo (EEE), Reino Unido o Suiza, las siguientes disposiciones adicionales aplican a ti." },
            { type: "paragraph", text: "Base legal: utilizamos tu consentimiento (Art. 6(1)(a) RGPD) como base legal para la publicidad personalizada. El interés legítimo (Art. 6(1)(f)) se aplica al análisis de juego y mejora del servicio." },
            { type: "paragraph", text: "Al iniciar nuestros juegos por primera vez, se te presentará un aviso de consentimiento certificado (mediante Google UMP / IAB TCF v2) donde podrás aceptar o rechazar la publicidad personalizada. Si rechazas, solo verás anuncios contextuales no personalizados." },
            { type: "paragraph", text: "Puedes retirar o modificar tu consentimiento en cualquier momento desde Configuración > Privacidad dentro de la aplicación." },
            { type: "paragraph", text: "Tienes los siguientes derechos sobre tus datos:" },
            { type: "list", items: [
              "Acceso: solicitar una copia de los datos que tenemos sobre ti.",
              "Rectificación: corregir datos inexactos.",
              "Supresión: solicitar la eliminación de tus datos ('derecho al olvido').",
              "Limitación: restringir el tratamiento de tus datos.",
              "Portabilidad: recibir tus datos en formato estructurado.",
              "Oposición: oponerte al tratamiento basado en interés legítimo.",
              "Reclamación: presentar una queja ante la autoridad de protección de datos de tu país.",
            ]},
            { type: "email", text: "Para ejercer estos derechos: realmpixelgames@gmail.com" },
          ],
        },
        {
          title: "7. Residentes de California (CCPA / CPRA)",
          content: [
            { type: "paragraph", text: "Si resides en California, tienes derechos adicionales bajo la Ley de Privacidad del Consumidor de California (CCPA) y la Ley de Derechos de Privacidad de California (CPRA)." },
            { type: "paragraph", text: "Reconocemos que compartir tu ID de publicidad con redes de anuncios puede calificar como 'compartir' información personal bajo la CCPA, incluso si no constituye una 'venta' en el sentido tradicional." },
            { type: "paragraph", text: "Como residente de California, tienes los siguientes derechos:" },
            { type: "list", items: [
              "Derecho a saber: qué información personal recopilamos, usamos y compartimos.",
              "Derecho a eliminar: solicitar la eliminación de tu información personal.",
              "Derecho a corregir: solicitar la corrección de información inexacta.",
              "Derecho a optar por no participar: no participar en la venta/compartición de tu información personal.",
              "Derecho a la no discriminación: no recibirás un trato diferente por ejercer estos derechos.",
            ]},
            { type: "paragraph", text: "Los menores de 16 años requieren consentimiento afirmativo (opt-in) antes de que compartamos su información personal con fines publicitarios. Los menores de 13 años requieren consentimiento parental verificable." },
            { type: "paragraph", text: "Respetamos las señales del Control de Privacidad Global (GPC). Para ejercer tus derechos, contáctanos en:" },
            { type: "email", text: "realmpixelgames@gmail.com" },
          ],
        },
        {
          title: "8. Privacidad de Menores (COPPA)",
          content: [
            { type: "paragraph", text: "Nuestros juegos están dirigidos a audiencias generales y no están específicamente diseñados para menores de 13 años. No recopilamos conscientemente información personal de niños menores de 13 años." },
            { type: "paragraph", text: "Si descubrimos que hemos recopilado inadvertidamente información de un menor de 13 años sin el consentimiento parental requerido, eliminaremos dicha información de inmediato." },
            { type: "paragraph", text: "No mostramos publicidad personalizada o conductual a usuarios que sabemos que son menores de 13 años. En esos casos, solo se sirven anuncios contextuales no personalizados, en cumplimiento con la Regla COPPA de la FTC (efectiva desde el 23 de junio de 2025)." },
            { type: "paragraph", text: "Si eres padre o tutor y crees que tu hijo nos ha proporcionado información personal, contáctanos para solicitar su eliminación:" },
            { type: "email", text: "realmpixelgames@gmail.com" },
          ],
        },
        {
          title: "9. Retención de Datos",
          content: [
            { type: "paragraph", text: "Conservamos tu información durante el tiempo que sea necesario para los fines descritos en esta política, o según lo requiera la ley. Los datos de juego se conservan mientras tu cuenta esté activa. Los datos de análisis y publicidad se conservan según las políticas de cada socio tercero." },
            { type: "paragraph", text: "Puedes solicitar la eliminación de tus datos en cualquier momento contactándonos. Ten en cuenta que algunos datos pueden conservarse por razones legales o técnicas durante un período limitado adicional." },
          ],
        },
        {
          title: "10. Seguridad",
          content: [
            { type: "paragraph", text: "Implementamos medidas técnicas y organizativas razonables para proteger tu información contra acceso no autorizado, pérdida o alteración. Sin embargo, ningún método de transmisión por Internet o almacenamiento electrónico es 100% seguro." },
            { type: "paragraph", text: "Te recomendamos mantener tu dispositivo actualizado y protegido para reducir riesgos de seguridad adicionales." },
          ],
        },
        {
          title: "11. Cambios en esta Política",
          content: [
            { type: "paragraph", text: "Podemos actualizar esta Política de Privacidad periódicamente. Cuando lo hagamos, actualizaremos la fecha de 'Última actualización' en la parte superior de esta página. Para cambios significativos, te notificaremos mediante un aviso dentro de la aplicación o por correo electrónico si disponemos de tu dirección." },
            { type: "paragraph", text: "Te recomendamos revisar esta política periódicamente. El uso continuado de nuestros servicios tras la publicación de cambios implica tu aceptación de la política actualizada." },
          ],
        },
        {
          title: "12. Contacto",
          content: [
            { type: "paragraph", text: "Si tienes preguntas, inquietudes o deseas ejercer tus derechos de privacidad, contáctanos en:" },
            { type: "email", text: "realmpixelgames@gmail.com" },
            { type: "paragraph", text: "Ubicación: Global / Remoto" },
          ],
        },
      ],
    },
    terms: {
      badge: "Legal",
      title: "Términos y Condiciones",
      updated: "Última actualización: 8 de abril de 2025",
      back: "Volver",
      sections: [
        {
          title: "1. Aceptación de los Términos",
          content: [
            "Bienvenido a Realm Pixel Games. Al acceder o utilizar nuestro sitio web, juegos, aplicaciones u otros servicios proporcionados por Realm Pixel Games (colectivamente, el \"Servicio\"), aceptas quedar vinculado por estos Términos y Condiciones (\"Términos\"). Si no estás de acuerdo con estos Términos, no utilices el Servicio.",
            "Estos Términos se aplican a todos los usuarios del Servicio, incluyendo visitantes, jugadores y cualquier otro individuo que acceda o utilice el Servicio de cualquier manera.",
          ],
        },
        {
          title: "2. Elegibilidad y Consentimiento Parental",
          content: [
            "Debes tener al menos 13 años para utilizar el Servicio. Si tienes entre 13 y 17 años, tu padre, madre o tutor legal debe haber revisado y aceptado estos Términos en tu nombre antes de que uses el Servicio.",
            "Si eres padre, madre o tutor legal que otorga permiso a un menor para usar el Servicio, aceptas estos Términos en su nombre y asumes plena responsabilidad por su uso, incluyendo cualquier compra dentro de la aplicación que realicen.",
            "No recopilamos conscientemente información personal de menores de 13 años sin el consentimiento parental verificable, de conformidad con las leyes de protección de la privacidad infantil aplicables.",
          ],
        },
        {
          title: "3. Concesión de Licencia",
          content: [
            "Sujeto al cumplimiento de estos Términos, Realm Pixel Games te otorga una licencia limitada, no exclusiva, intransferible y revocable para acceder y usar el Servicio con fines de entretenimiento personal y no comercial.",
            "No está permitido:",
            "• Copiar, modificar o distribuir el Servicio o cualquier parte del mismo\n• Sublicenciar, vender o transferir tu licencia a terceros\n• Usar el Servicio con fines comerciales\n• Realizar ingeniería inversa, descompilar o desensamblar cualquier parte del Servicio\n• Crear obras derivadas basadas en el Servicio",
            "No eres propietario de nuestros juegos — tienes una licencia para usarlos. Realm Pixel Games y sus licenciantes conservan todos los derechos, títulos e intereses sobre el Servicio y toda la propiedad intelectual que contiene.",
          ],
        },
        {
          title: "4. Compras Dentro de la App y Artículos Virtuales",
          content: [
            "Algunas partes del Servicio pueden permitirte comprar moneda virtual, artículos u otros bienes digitales (\"Artículos Virtuales\"). Los Artículos Virtuales no tienen valor monetario real y no pueden canjearse por dinero real, bienes o servicios fuera del Servicio.",
            "Todas las compras son definitivas y no reembolsables, salvo cuando lo exija la legislación aplicable. Realm Pixel Games se reserva el derecho de gestionar, modificar o eliminar Artículos Virtuales en cualquier momento sin previo aviso.",
            "Los reembolsos por compras realizadas a través de Google Play Store o Apple App Store están sujetos a las políticas de reembolso de cada plataforma. Contacta directamente con la plataforma para solicitar reembolsos.",
            "Si tu cuenta es suspendida o cancelada por infracción de estos Términos, perderás el acceso a todos los Artículos Virtuales y compras sin compensación ni reembolso.",
          ],
        },
        {
          title: "5. Conducta Prohibida",
          content: [
            "Aceptas no participar en ninguna de las siguientes actividades:",
            "• Usar trucos, bots, scripts, mods o cualquier software no autorizado de terceros\n• Explotar errores, glitches o funciones no intencionadas del Servicio\n• Intentar realizar ingeniería inversa o manipular el Servicio\n• Acosar, amenazar o abusar de otros usuarios\n• Publicar o transmitir discursos de odio, contenido ofensivo o ilegal\n• Suplantar la identidad de cualquier persona o entidad, incluido el personal de Realm Pixel Games\n• Comprar, vender o intercambiar cuentas\n• Usar el Servicio para actividades relacionadas con el juego de azar\n• Recopilar datos del Servicio mediante medios automatizados\n• Intentar interrumpir o comprometer la integridad de nuestros servidores\n• Manipular partidas o cualquier forma de manipulación competitiva",
            "Las infracciones pueden resultar en advertencias, suspensión temporal o cancelación permanente de la cuenta a nuestra entera discreción, sin previo aviso y sin reembolso.",
          ],
        },
        {
          title: "6. Propiedad Intelectual",
          content: [
            "Todo el contenido, las funciones y la funcionalidad del Servicio — incluyendo, entre otros, el código fuente, las mecánicas de juego, el arte, los personajes, las animaciones, la música, el texto, los gráficos y los logotipos — son propiedad exclusiva de Realm Pixel Games o sus licenciantes y están protegidos por las leyes internacionales de derechos de autor, marcas registradas y otras leyes de propiedad intelectual.",
            "No puedes reproducir, distribuir, modificar, crear obras derivadas, mostrar públicamente ni usar de ninguna otra manera cualquier contenido del Servicio sin nuestro permiso previo por escrito.",
          ],
        },
        {
          title: "7. Privacidad y Datos",
          content: [
            "Tu uso del Servicio también se rige por nuestra Política de Privacidad, que se incorpora a estos Términos por referencia. Al usar el Servicio, consientes la recopilación y uso de información según se describe en nuestra Política de Privacidad.",
            "Podemos recopilar datos de juego, información del dispositivo y estadísticas de uso para mejorar el Servicio y potenciar tu experiencia. Podemos monitorear las comunicaciones dentro del juego para hacer cumplir estos Términos y mantener un entorno justo y seguro.",
          ],
        },
        {
          title: "8. Cambios en el Servicio y Disponibilidad",
          content: [
            "Realm Pixel Games se reserva el derecho de modificar, actualizar, suspender o interrumpir cualquier parte del Servicio en cualquier momento, con o sin previo aviso. No garantizamos la disponibilidad continua y no somos responsables de ninguna interrupción, retraso o pérdida de datos resultante de problemas técnicos, mantenimiento o cambios en el Servicio.",
            "El contenido, las funciones y las mecánicas del juego pueden cambiar con las actualizaciones. No estamos obligados a mantener ninguna función o contenido específico de manera indefinida.",
          ],
        },
        {
          title: "9. Descargos de Responsabilidad y Limitación de Responsabilidad",
          content: [
            "El Servicio se proporciona \"tal cual\" y \"según disponibilidad\", sin garantías de ningún tipo, ya sean expresas o implícitas, incluyendo pero no limitadas a garantías de comerciabilidad, idoneidad para un propósito particular o no infracción.",
            "En la máxima medida permitida por la legislación aplicable, Realm Pixel Games no será responsable de ningún daño indirecto, incidental, especial, consecuente o punitivo, incluyendo pero no limitado a pérdida de datos, pérdida de progreso en el juego o pérdida de beneficios, derivados del uso o la imposibilidad de usar el Servicio.",
            "En jurisdicciones que no permiten ciertas limitaciones de responsabilidad, nuestra responsabilidad se limita a la máxima medida permitida por la ley.",
          ],
        },
        {
          title: "10. Cancelación de Cuenta",
          content: [
            "Nos reservamos el derecho de suspender o cancelar permanentemente tu acceso al Servicio en cualquier momento, con o sin previo aviso, por cualquier infracción de estos Términos o por cualquier otro motivo a nuestra entera discreción.",
            "Tras la cancelación, tu derecho a usar el Servicio cesará de inmediato. Perderás el acceso a todos los Artículos Virtuales, el progreso en el juego y el contenido comprado, sin derecho a compensación ni reembolso.",
          ],
        },
        {
          title: "11. Resolución de Disputas y Legislación Aplicable",
          content: [
            "Estos Términos se regirán e interpretarán de acuerdo con la legislación aplicable, sin tener en cuenta los principios de conflicto de leyes. Cualquier disputa que surja de o relacionada con estos Términos o el Servicio se intentará resolver primero mediante negociación de buena fe.",
            "Si una disputa no puede resolverse de manera informal, aceptas resolverla mediante arbitraje vinculante en lugar de en los tribunales, salvo cuando lo prohíba la ley. Renuncias a cualquier derecho a participar en una demanda colectiva contra Realm Pixel Games.",
          ],
        },
        {
          title: "12. Cambios en estos Términos",
          content: [
            "Podemos actualizar estos Términos en cualquier momento. Cuando lo hagamos, revisaremos la fecha de \"Última actualización\" en la parte superior de esta página. Tu uso continuado del Servicio después de cualquier cambio constituye tu aceptación de los nuevos Términos.",
            "Te recomendamos revisar estos Términos periódicamente para mantenerte informado de cualquier actualización.",
          ],
        },
        {
          title: "13. Contacto",
          content: [
            "Si tienes alguna pregunta sobre estos Términos, contáctanos en:",
          ],
          email: "realmpixelgames@gmail.com",
        },
      ],
    },
  },
  en: {
    nav: {
      about: "About",
      services: "Services",
      features: "Features",
      workflow: "Process",
      games: "Games",
      contact: "Contact",
      cta: "Let's Talk",
    },
    hero: {
      title1: "We create games",
      title2: "that inspire.",
      subtitle: "We build mobile experiences for Android & iOS with identity, creativity, and cutting-edge technology.",
      cta1: "Our vision",
    },
    about: {
      tag: "Who we are",
      title: "A studio with creative and technical vision",
      description: "At Realm Pixel Games we combine distinctive visual design, innovative mechanics, and technical optimization to create mobile games that stand out. Every project is born from a bold idea and transforms into a memorable experience.",
      values: [
        { title: "Creativity", desc: "Original ideas that break molds and generate unique experiences." },
        { title: "Gameplay", desc: "Addictive mechanics designed for engagement and retention." },
        { title: "Visual Design", desc: "Carefully crafted aesthetics with unique identity in every pixel." },
        { title: "Mobile First", desc: "Native optimization for Android & iOS from day one." },
        { title: "Innovation", desc: "Cutting-edge technology applied to game development." },
      ],
    },
    services: {
      tag: "What we do",
      title: "Development services",
      items: [
        { title: "Android Games", desc: "Native, optimized development for the Android ecosystem with exceptional performance." },
        { title: "iOS Games", desc: "Polished, fluid experiences designed for the Apple ecosystem." },
        { title: "Mechanics Design", desc: "Addictive gameplay loops, progression systems, and game balancing." },
        { title: "Gaming UI/UX", desc: "Intuitive, attractive interfaces that enhance the player experience." },
        { title: "Optimization", desc: "Maximum performance on mobile devices without sacrificing visual quality." },
        { title: "Prototyping", desc: "Rapid conceptualization and functional prototypes to validate ideas." },
      ],
    },
    features: {
      tag: "Why choose us",
      title: "What makes us different",
      items: [
        { title: "Engaging Experiences", desc: "Games that capture attention from the very first second." },
        { title: "Distinctive Design", desc: "Unique visual identity that stands out in any app store." },
        { title: "Optimized Performance", desc: "Guaranteed smoothness even on mid-range devices." },
        { title: "Engagement Focus", desc: "Mechanics designed to keep players coming back for more." },
        { title: "Cross-Platform", desc: "One game, multiple platforms. Android & iOS without compromise." },
        { title: "Creative Vision", desc: "Every project is an opportunity to create something extraordinary." },
      ],
    },
    workflow: {
      tag: "Our process",
      title: "From idea to launch",
      steps: [
        { title: "Idea", desc: "Everything starts with a vision. We explore concepts and define the creative direction." },
        { title: "Concept", desc: "We structure the core mechanic, narrative, and game aesthetics." },
        { title: "Design", desc: "We create the visual art, UI/UX, and complete graphic identity." },
        { title: "Development", desc: "Programming, system integration, and product construction." },
        { title: "Testing", desc: "Rigorous QA, performance testing, and balance adjustments." },
        { title: "Launch", desc: "Store publication, launch strategy, and marketing." },
        { title: "Evolution", desc: "Updates, new content, and continuous improvement based on data." },
      ],
    },
    portfolio: {
      tag: "Our games",
      title: "Projects that come to life",
      games: [
        { title: "Neon Drift", genre: "Action / Arcade", platform: "Android & iOS", status: "In Development", desc: "Futuristic racing at extreme speed through neon cities." },
        { title: "Pixel Realms", genre: "RPG / Adventure", platform: "Android & iOS", status: "Prototype", desc: "A pixelated world full of mysteries, dungeons, and magic." },
        { title: "Cyber Stack", genre: "Puzzle / Strategy", platform: "Android", status: "Coming Soon", desc: "Stack, connect, and hack your way through cyberpunk levels." },
        { title: "Shadow Sprint", genre: "Platformer / Runner", platform: "iOS", status: "Concept", desc: "Run, jump, and dodge in a world of shadows and lights." },
      ],
    },
    cta: {
      title: "Let's build the next great mobile game",
      subtitle: "Have an idea? We'll turn it into an experience players will love.",
      button: "Contact us",
    },
    contact: {
      tag: "Contact",
      title: "Let's talk about your project",
      subtitle: "We're ready to hear your idea and turn it into reality.",
      name: "Your name",
      email: "Your email",
      message: "Your message",
      send: "Send message",
      info: {
        email: "Email",
        social: "Social Media",
        location: "Location",
        locationValue: "Global / Remote",
      },
    },
    footer: {
      tagline: "Creating extraordinary mobile experiences.",
      rights: "All rights reserved.",
      nav: "Navigation",
      social: "Social",
    },
    privacy: {
      badge: "Legal",
      title: "Privacy Policy",
      updated: "Last updated: April 8, 2025",
      back: "Back",
      sections: [
        {
          title: "1. Introduction",
          content: [
            { type: "paragraph", text: "Realm Pixel Games ('we', 'our', 'us') operates this website and the mobile games available on the Google Play Store and Apple App Store. This Privacy Policy explains how we collect, use, share, and protect your information when you use our services." },
            { type: "paragraph", text: "By using our services, you agree to the practices described in this policy. If you do not agree, please do not use our services." },
            { type: "email", text: "Privacy contact: realmpixelgames@gmail.com" },
          ],
        },
        {
          title: "2. Information We Collect",
          content: [
            { type: "paragraph", text: "We collect the following types of information:" },
            { type: "list", items: [
              "Device identifiers: Advertising ID (GAID on Android, IDFA on iOS), device model, operating system and version.",
              "IP address: used to determine your approximate geographic region.",
              "Gameplay data: progress, scores, achievements, session time, and in-game behavior.",
              "Purchase data: in-app purchase history (we do not store payment card details).",
              "Technical data: app version, device language, time zone, performance logs, and crash reports.",
            ]},
            { type: "paragraph", text: "Some of this information is collected directly by us and some by third-party SDKs integrated in our games, as detailed in Section 4." },
          ],
        },
        {
          title: "3. How We Use Your Information",
          content: [
            { type: "list", items: [
              "Operate and improve our games and services.",
              "Display relevant advertisements (in the free version) and measure their effectiveness.",
              "Process in-app purchases, including the ad-free upgrade option.",
              "Analyze gameplay behavior to enhance the user experience.",
              "Detect and prevent fraud, cheating, or abusive use.",
              "Comply with applicable legal obligations.",
            ]},
          ],
        },
        {
          title: "4. Advertising & Third-Party Networks",
          content: [
            { type: "paragraph", text: "Our free-version games display ads provided by third-party advertising networks. These networks may collect your Advertising ID, IP address, and usage data to serve personalized ads based on your interests." },
            { type: "paragraph", text: "We work with the following advertising and analytics partners:" },
            { type: "table",
              headers: ["Partner", "Country", "Purpose"],
              rows: [
                ["Google AdMob", "USA", "Ad network & mediation"],
                ["Unity Ads / ironSource LevelPlay", "USA / Israel", "Ad network & mediation"],
                ["AppLovin / MAX", "USA", "Ad network & mediation"],
                ["Meta Audience Network", "USA", "Ad network"],
                ["Vungle / Liftoff Monetize", "USA", "Video & rewarded ads"],
                ["Google Firebase", "USA", "Analytics & crash reporting"],
                ["AppsFlyer", "Israel / USA", "Marketing attribution"],
                ["Apple App Store", "USA", "Purchase processing (iOS)"],
                ["Google Play", "USA", "Purchase processing (Android)"],
              ],
            },
            { type: "paragraph", text: "You can opt out of personalized ads in your device settings:" },
            { type: "list", items: [
              "iOS: Settings > Privacy & Security > Tracking → disable 'Allow Apps to Request to Track'.",
              "Android: Settings > Google > Ads → enable 'Opt out of Ads Personalization'.",
            ]},
          ],
        },
        {
          title: "5. In-App Purchases & Ad-Free Option",
          content: [
            { type: "paragraph", text: "Our games offer a one-time purchase to remove all ads. Upon completing this purchase:" },
            { type: "list", items: [
              "No advertisements will be displayed during your use of the app.",
              "We will stop sharing your Advertising ID with our ad networks for in-app advertising purposes.",
              "The data-sharing practices described in Section 4 related to advertising will not apply to your use of the app.",
            ]},
            { type: "paragraph", text: "Payment is processed directly by Apple App Store or Google Play. Realm Pixel Games does not store or access your payment data. For refund requests, please refer to the refund policy of the relevant platform." },
          ],
        },
        {
          title: "6. European Users (GDPR)",
          content: [
            { type: "paragraph", text: "If you reside in the European Economic Area (EEA), United Kingdom, or Switzerland, the following additional provisions apply to you." },
            { type: "paragraph", text: "Legal basis: we use your consent (Art. 6(1)(a) GDPR) as the legal basis for personalized advertising. Legitimate interest (Art. 6(1)(f)) applies to gameplay analytics and service improvement." },
            { type: "paragraph", text: "When you first launch our games, you will be presented with a certified consent notice (via Google UMP / IAB TCF v2) where you can accept or decline personalized advertising. If you decline, you will only see contextual, non-personalized ads." },
            { type: "paragraph", text: "You can withdraw or modify your consent at any time from Settings > Privacy within the app." },
            { type: "paragraph", text: "You have the following rights regarding your data:" },
            { type: "list", items: [
              "Access: request a copy of the data we hold about you.",
              "Rectification: correct inaccurate data.",
              "Erasure: request deletion of your data ('right to be forgotten').",
              "Restriction: restrict the processing of your data.",
              "Portability: receive your data in a structured format.",
              "Objection: object to processing based on legitimate interest.",
              "Complaint: lodge a complaint with your country's data protection authority.",
            ]},
            { type: "email", text: "To exercise these rights: realmpixelgames@gmail.com" },
          ],
        },
        {
          title: "7. California Residents (CCPA / CPRA)",
          content: [
            { type: "paragraph", text: "If you reside in California, you have additional rights under the California Consumer Privacy Act (CCPA) and the California Privacy Rights Act (CPRA)." },
            { type: "paragraph", text: "We acknowledge that sharing your Advertising ID with ad networks may qualify as 'sharing' personal information under the CCPA, even if it does not constitute a 'sale' in the traditional sense." },
            { type: "paragraph", text: "As a California resident, you have the following rights:" },
            { type: "list", items: [
              "Right to Know: what personal information we collect, use, and share.",
              "Right to Delete: request deletion of your personal information.",
              "Right to Correct: request correction of inaccurate information.",
              "Right to Opt-Out: opt out of the sale/sharing of your personal information.",
              "Right to Non-Discrimination: you will not receive different treatment for exercising these rights.",
            ]},
            { type: "paragraph", text: "Users under 16 require affirmative consent (opt-in) before we share their personal information for advertising purposes. Users under 13 require verifiable parental consent." },
            { type: "paragraph", text: "We respect Global Privacy Control (GPC) signals. To exercise your rights, contact us at:" },
            { type: "email", text: "realmpixelgames@gmail.com" },
          ],
        },
        {
          title: "8. Children's Privacy (COPPA)",
          content: [
            { type: "paragraph", text: "Our games are directed to general audiences and are not specifically designed for children under 13. We do not knowingly collect personal information from children under 13." },
            { type: "paragraph", text: "If we discover that we have inadvertently collected information from a child under 13 without the required parental consent, we will delete such information immediately." },
            { type: "paragraph", text: "We do not serve personalized or behavioral advertising to users we know to be under 13. Only contextual, non-personalized ads are served in those circumstances, in compliance with the FTC COPPA Rule (effective June 23, 2025)." },
            { type: "paragraph", text: "If you are a parent or guardian and believe your child has provided us with personal information, please contact us to request deletion:" },
            { type: "email", text: "realmpixelgames@gmail.com" },
          ],
        },
        {
          title: "9. Data Retention",
          content: [
            { type: "paragraph", text: "We retain your information for as long as necessary for the purposes described in this policy, or as required by law. Gameplay data is retained while your use of the service is active. Analytics and advertising data is retained according to each third-party partner's own policies." },
            { type: "paragraph", text: "You may request deletion of your data at any time by contacting us. Please note that some data may be retained for legal or technical reasons for a limited additional period." },
          ],
        },
        {
          title: "10. Security",
          content: [
            { type: "paragraph", text: "We implement reasonable technical and organizational measures to protect your information against unauthorized access, loss, or alteration. However, no method of internet transmission or electronic storage is 100% secure." },
            { type: "paragraph", text: "We recommend keeping your device updated and protected to reduce additional security risks." },
          ],
        },
        {
          title: "11. Changes to This Policy",
          content: [
            { type: "paragraph", text: "We may update this Privacy Policy periodically. When we do, we will update the 'Last updated' date at the top of this page. For significant changes, we will notify you via an in-app notice or by email if we have your address." },
            { type: "paragraph", text: "We encourage you to review this policy periodically. Continued use of our services after changes are posted constitutes your acceptance of the updated policy." },
          ],
        },
        {
          title: "12. Contact",
          content: [
            { type: "paragraph", text: "If you have questions, concerns, or wish to exercise your privacy rights, please contact us at:" },
            { type: "email", text: "realmpixelgames@gmail.com" },
            { type: "paragraph", text: "Location: Global / Remote" },
          ],
        },
      ],
    },
    terms: {
      badge: "Legal",
      title: "Terms & Conditions",
      updated: "Last updated: April 8, 2025",
      back: "Back",
      sections: [
        {
          title: "1. Acceptance of Terms",
          content: [
            "Welcome to Realm Pixel Games. By accessing or using our website, games, applications, or any other services provided by Realm Pixel Games (collectively, the \"Service\"), you agree to be bound by these Terms and Conditions (\"Terms\"). If you do not agree to these Terms, do not use the Service.",
            "These Terms apply to all users of the Service, including visitors, players, and any other individuals who access or use the Service in any way.",
          ],
        },
        {
          title: "2. Eligibility & Parental Consent",
          content: [
            "You must be at least 13 years of age to use the Service. If you are between 13 and 17 years old, your parent or legal guardian must have reviewed and agreed to these Terms on your behalf before you use the Service.",
            "If you are a parent or legal guardian granting permission for your child to use the Service, you agree to these Terms on their behalf and assume full responsibility for their use of the Service, including any in-app purchases made.",
            "We do not knowingly collect personal information from children under the age of 13 without verifiable parental consent, in compliance with applicable child privacy protection laws.",
          ],
        },
        {
          title: "3. License Grant",
          content: [
            "Subject to your compliance with these Terms, Realm Pixel Games grants you a limited, non-exclusive, non-transferable, revocable license to access and use the Service for your personal, non-commercial entertainment purposes.",
            "You may not:",
            "• Copy, modify, or distribute the Service or any part of it\n• Sublicense, sell, or transfer your license to anyone else\n• Use the Service for any commercial purpose\n• Reverse engineer, decompile, or disassemble any part of the Service\n• Create derivative works based on the Service",
            "You do not own our games — you hold a license to use them. Realm Pixel Games and its licensors retain all rights, title, and interest in and to the Service and all intellectual property therein.",
          ],
        },
        {
          title: "4. In-App Purchases & Virtual Items",
          content: [
            "Some parts of the Service may allow you to purchase virtual currency, items, or other digital goods (\"Virtual Items\"). Virtual Items have no monetary value and cannot be exchanged for real money, goods, or services outside of the Service.",
            "All purchases are final and non-refundable, except where required by applicable law. Realm Pixel Games reserves the right to manage, modify, or eliminate Virtual Items at any time without notice or liability to you.",
            "Refunds for purchases made through the Google Play Store or Apple App Store are subject to the respective platform's refund policies. Please contact the platform directly for refund requests.",
            "If your account is suspended or terminated for violation of these Terms, you will lose access to all Virtual Items and purchases without compensation or refund.",
          ],
        },
        {
          title: "5. Prohibited Conduct",
          content: [
            "You agree not to engage in any of the following activities:",
            "• Using cheats, bots, scripts, mods, or any unauthorized third-party software\n• Exploiting bugs, glitches, or unintended features of the Service\n• Attempting to reverse engineer, decompile, or tamper with the Service\n• Harassing, threatening, or abusing other users\n• Posting or transmitting hate speech, offensive, or illegal content\n• Impersonating any person or entity, including Realm Pixel Games staff\n• Buying, selling, or trading accounts\n• Using the Service for gambling or gambling-related activities\n• Collecting or harvesting data from the Service through automated means\n• Attempting to disrupt, overload, or compromise the integrity of our servers\n• Engaging in match-fixing or any form of competitive manipulation",
            "Violations may result in warnings, temporary suspension, or permanent account termination at our sole discretion, without notice and without refund.",
          ],
        },
        {
          title: "6. Intellectual Property",
          content: [
            "All content, features, and functionality of the Service — including but not limited to source code, game mechanics, artwork, characters, animations, music, text, graphics, and logos — are the exclusive property of Realm Pixel Games or its licensors and are protected by international copyright, trademark, and other intellectual property laws.",
            "You may not reproduce, distribute, modify, create derivative works of, publicly display, or otherwise use any content from the Service without our prior written permission.",
          ],
        },
        {
          title: "7. Privacy & Data",
          content: [
            "Your use of the Service is also governed by our Privacy Policy, which is incorporated into these Terms by reference. By using the Service, you consent to the collection and use of information as described in our Privacy Policy.",
            "We may collect gameplay data, device information, and usage statistics to improve the Service and enhance your experience. We may monitor in-game communications to enforce these Terms and maintain a fair and safe environment.",
          ],
        },
        {
          title: "8. Service Changes & Availability",
          content: [
            "Realm Pixel Games reserves the right to modify, update, suspend, or discontinue any part of the Service at any time, with or without notice. We do not guarantee continuous availability, and we are not liable for any interruption, delay, or loss of data resulting from technical issues, maintenance, or changes to the Service.",
            "Game content, features, and mechanics may change with updates. We are not obligated to maintain any specific feature or content indefinitely.",
          ],
        },
        {
          title: "9. Disclaimers & Limitation of Liability",
          content: [
            "The Service is provided \"as is\" and \"as available\" without warranties of any kind, either express or implied, including but not limited to warranties of merchantability, fitness for a particular purpose, or non-infringement.",
            "To the fullest extent permitted by applicable law, Realm Pixel Games shall not be liable for any indirect, incidental, special, consequential, or punitive damages, including but not limited to loss of data, loss of in-game progress, or loss of profits, arising from your use of or inability to use the Service.",
            "In jurisdictions that do not allow certain limitations of liability, our liability is limited to the maximum extent permitted by law.",
          ],
        },
        {
          title: "10. Account Termination",
          content: [
            "We reserve the right to suspend or permanently terminate your access to the Service at any time, with or without notice, for any violation of these Terms or for any other reason at our sole discretion.",
            "Upon termination, your right to use the Service will immediately cease. You will lose access to all Virtual Items, in-game progress, and purchased content, with no right to compensation or refund.",
          ],
        },
        {
          title: "11. Dispute Resolution & Governing Law",
          content: [
            "These Terms shall be governed by and construed in accordance with applicable laws, without regard to conflict of law principles. Any disputes arising from or relating to these Terms or the Service shall first be attempted to be resolved through good-faith negotiation.",
            "If a dispute cannot be resolved informally, you agree to resolve it through binding arbitration rather than in court, except where prohibited by law. You waive any right to participate in a class action lawsuit against Realm Pixel Games.",
          ],
        },
        {
          title: "12. Changes to These Terms",
          content: [
            "We may update these Terms at any time. When we do, we will revise the \"Last updated\" date at the top of this page. Your continued use of the Service after any changes constitutes your acceptance of the new Terms.",
            "We encourage you to review these Terms periodically to stay informed of any updates.",
          ],
        },
        {
          title: "13. Contact",
          content: [
            "If you have any questions about these Terms, please contact us at:",
          ],
          email: "realmpixelgames@gmail.com",
        },
      ],
    },
  },
};

export default translations;
